import { memo } from 'react';
import { Box } from '@material-ui/core';
import SEmptyState from '@setvi/shared/components/sempty-state';
import emptyFolderSearch from '../../../assets/images/empty-folder-search.png';
import { NOTICE_COPY } from '../constants';
import { NoticeVariant, QuoteShareContact } from '../types';
import { useStyles } from '../styles';

interface NoticeProps {
  variant: NoticeVariant;
  contact?: QuoteShareContact;
}

const formatContact = (contact: QuoteShareContact) =>
  [contact.name, contact.email, contact.phone].filter(Boolean).join(' · ');

const Notice = ({ variant, contact }: NoticeProps) => {
  const styles = useStyles();
  const copy = NOTICE_COPY[variant];

  const additionalContent =
    copy.showContact && contact ? (
      <Box className={styles.contact}>{formatContact(contact)}</Box>
    ) : undefined;

  return (
    <Box className={styles.noticeContainer}>
      <SEmptyState
        imageSrc={emptyFolderSearch}
        imageAlt="Quote unavailable"
        title={copy.title}
        subTitle={copy.body}
        additionalContent={additionalContent}
      />
    </Box>
  );
};

export default memo(Notice);
